import { ResourceItem } from '../interface/resources.model';
import { ResourceFilters } from '../interface/resource-filters.model';

export function filterResources(
  items: ResourceItem[],
  filters: ResourceFilters
): ResourceItem[] {
  if (!items?.length) return [];

  return items.filter(item => {
    if (filters.topic && !item.topics.includes(filters.topic)) {
      return false;
    }

    if (filters.type && item.type !== filters.type) {
      return false;
    }

    if (
      filters.search &&
      !item.title.toLowerCase().includes(filters.search.toLowerCase())
    ) {
      return false;
    }

    return true;
  });
}

export function slugify(value?: string): string {
  if (!value) return '';

  return value
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}